import { getEnvironment } from "@/utils/env";

// Grab 'environment' query param, if present, on page load. This will be used
// for the duration of the session as the 'environment' until page is reloaded.
let environment = new URL(location.href).searchParams.get("environment");

// Otherwise fall back on default environment mapping using domain name.
if (!environment) environment = process.env.VUE_APP_BUILD_TARGET || getEnvironment();

// Map 'development' to 'dev' for string interpolation when building URLs.
if (environment === "development") environment = "dev";

let auth, sso, provision, model, keychain, remote, eapi, eapi2, graph, graphSub, data, camelot, teamhub;
switch (environment) {
	case "dev":
	case "staging":
		auth = `https://auth-v2-${environment}.k4connect.com`;
		sso = `https://api-${environment}.k4connect.com/v2/sso`;
		provision = `https://api-${environment}.k4connect.com/v2/provision`;
		model = `https://k4model-interaction-${environment}.k4connect.com/model`;
		keychain = `https://api-${environment}.k4connect.com/v2/keychain`;
		remote = `https://api-${environment}.k4connect.com/v2/remote`;
		eapi = `https://eapi-${environment}.k4connect.com`;
		eapi2 = `https://eapi-v2-${environment}.k4connect.com`;
		graph = `https://graph-${environment}.k4connect.com/graphql`;
		graphSub = `wss://graph-${environment}.k4connect.com/subscribe`;
		data = `https://data-${environment}.k4connect.com`;
		camelot = `https://api-${environment}.k4connect.com/v4`;
		teamhub = `https://teamhub-${environment}.k4connect.com`;
		break;
	default:
		auth = `https://auth-v2.k4connect.com`;
		sso = `https://api.k4connect.com/v2/sso`;
		provision = `https://api.k4connect.com/v2/provision`;
		model = `https://k4model-interaction.k4connect.com/model`;
		keychain = `https://api.k4connect.com/v2/keychain`;
		remote = `https://api.k4connect.com/v2/remote`;
		eapi = `https://eapi.k4connect.com`;
		eapi2 = `https://eapi-v2.k4connect.com`;
		graph = `https://graph.k4connect.com/graphql`;
		graphSub = `wss://graph.k4connect.com/subscribe`;
		data = `https://data.k4connect.com`;
		camelot = `https://api.k4connect.com/v4`;
		teamhub = `https://teamhub.k4connect.com`;
		break;
}

export const AUTH_ENDPOINT = auth;
export const SSO_ENDPOINT = sso;
export const PROVISION_ENDPOINT = provision;
export const MODEL_ENDPOINT = model;
export const KEYCHAIN_ENDPOINT = keychain;
export const REMOTE_ENDPOINT = remote;
export const EAPI_ENDPOINT = eapi;
export const EAPI2_ENDPOINT = eapi2;
export const GRAPH_ENDPOINT = graph;
export const GRAPH_SUB_ENDPOINT = graphSub;
export const DATA_ENDPOINT = data;
export const CAMELOT_ENDPOINT = camelot;
export const TEAMHUB_ENDPOINT = teamhub;